import React from 'react'
import { AddRow,AddTable,AddColumn,
  RemoveColumn,RemoveRow,RemoveTable  } from '../img/'
import { Grid, IconButton, Paper,Snackbar } from '@material-ui/core';
import { FormatBold, FormatItalic, FormatUnderlined,
  FormatListNumbered,
  FormatListBulleted,
  Attachment
} from '@material-ui/icons'
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';

import { CustomTooltip } from './CustomTooltip';

const renderButton = (click, type, icon, help, disabled) => {
  const onClick = event => click(event, type)
  return (
    <CustomTooltip  placement="top" title={ help } enterDelay={ 100 } >
    <div>
      <IconButton onMouseDown={ onClick }  disabled={ ( !disabled || disabled === false ) ? false : true } >
        { icon }
      </IconButton>
    </div>
  </CustomTooltip>
  )
}

class DocBodyToolBar extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.isInTable!==nextProps.isInTable || this.props.isInEditor!==nextProps.isInEditor ||
     this.props.uploadingDisabled!==nextProps.uploadingDisabled
  }

  render(){
    const {isInTable,  onClickBlock, onClickMark, onClickTable, onUpload, isInEditor, uploadingDisabled} =this.props
    return (
      <Snackbar open={isInEditor} >
        <Paper>
          {isInTable ? (<Grid container direction='row' style={{ backgroundColor: '#EBEBEB' }}>
            {renderButton(onClickTable,'insert-row',<AddRow />, 'Agregar fila')}
            {renderButton(onClickTable,'insert-column',<AddColumn />, 'Agregar columna')}
            {renderButton(onClickTable,'remove-column',<RemoveColumn />,'Borrar columna')}
            {renderButton(onClickTable,'remove-row',<RemoveRow />,'Borrar fila')}
            {renderButton(onClickTable,'remove-table',<RemoveTable />,'Borrar tabla')}
          </Grid>) : null}
          <Grid container  direction='row' style={{ backgroundColor: '#EBEBEB' }}>
            {renderButton(onClickMark,'bold',<FormatBold />,'Negritas')}
            {renderButton(onClickMark,'italic',<FormatItalic />,'Itálica')}
            {renderButton(onClickMark,'underlined',<FormatUnderlined />,'Subrayado')}
            {renderButton(onClickTable,'insert-table',<AddTable />,'Agregar tabla')}
            {renderButton(onClickBlock,'numbered-list',<FormatListNumbered />,'Agregar lista')}
            {renderButton(onClickBlock,'bulleted-list',<FormatListBulleted />,'Agregar lista')}
            {renderButton(onUpload,'Attachment',<Attachment />,'Adjuntar archivo', uploadingDisabled)}
            {renderButton(onClickBlock,'align-left',<FormatAlignLeftIcon />,'Alinear Izquierda')}
            {renderButton(onClickBlock,'align-center',<FormatAlignCenterIcon  />,'Alinear Centro')}
            {renderButton(onClickBlock,'align-justify',<FormatAlignJustifyIcon />,'Alinear Justificado')}
            {renderButton(onClickBlock,'align-right',<FormatAlignRightIcon />,'Alinear Derecha')}
          </Grid>
        </Paper>
      </Snackbar>
    )
  }
}
export default DocBodyToolBar;



// WEBPACK FOOTER //
// ./src/components/DocBodyToolBar.js